import { SignInLayoutCombinedProps } from './types';

const usePresenter = (props: SignInLayoutCombinedProps): SignInLayoutCombinedProps => {
  return props;
};

export default usePresenter;
